// @greenlight-spec: 15-database-schema.md#release_validation_runs
// @greenlight-spec: 11-observability.md#release-validation-runs-section
// @greenlight-spec: 26-versioning-update-strategy.md#release-validation
// @greenlight-spec: decisions/0068-release-validation-on-shift-installs.md
import { z } from 'zod';
export const RELEASE_VALIDATION_SUITES = ['contract', 'e2e'];
export const RELEASE_VALIDATION_OUTCOMES = ['in_flight', 'passed', 'failed', 'timed_out'];
export const RELEASE_VALIDATION_CASE_OUTCOMES = ['passed', 'failed', 'skipped'];
/**
 * How long past a row's `deadline_at` the updater keeps holding and the worker
 * keeps waiting before the row is abandoned. One constant so the hold and the
 * abandon rule cannot disagree.
 */
export const RELEASE_VALIDATION_HOLD_GRACE_MS = 15 * 60 * 1000;
export const RELEASE_VALIDATION_BUILD_MAX = 64;
export const RELEASE_VALIDATION_CASE_ID_MAX = 32;
export const RELEASE_VALIDATION_STEP_MAX = 120;
export const RELEASE_VALIDATION_REASON_MAX = 120;
export const RELEASE_VALIDATION_CASES_MAX = 64;
export const RELEASE_VALIDATION_DEBUG_EXCERPT_MAX_CHARS = 4096;
/** A build name safe as a Table Storage row-key part: semver characters only. */
export const RELEASE_VALIDATION_BUILD_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._+-]{0,63}$/;
/** One case's result, as stored in `release_validation_runs.cases`. */
export const ReleaseValidationCaseSchema = z
    .object({
    id: z.string().min(1).max(RELEASE_VALIDATION_CASE_ID_MAX),
    outcome: z.enum(RELEASE_VALIDATION_CASE_OUTCOMES),
    duration_ms: z.number().int().nonnegative().nullable(),
    step: z.string().max(RELEASE_VALIDATION_STEP_MAX).nullable(),
})
    .strict();
/** `release_validation_runs.debug_excerpt` and the report's `debug_excerpt`: text only. */
export const ReleaseValidationDebugExcerptSchema = z
    .object({
    text: z.string().max(RELEASE_VALIDATION_DEBUG_EXCERPT_MAX_CHARS),
    truncated: z.boolean(),
})
    .strict();
/**
 * Cap on the serialized `release_validation_runs` section. The collector shrinks
 * an over-cap section by dropping older rows' excerpts, then passing cases, then
 * the oldest rows, so the report always fits.
 */
export const FLEET_RELEASE_VALIDATION_SECTION_MAX_BYTES = 8 * 1024;
//# sourceMappingURL=vocabulary.js.map